<template>
    <rkm-overlay>
        <rkm-layout-body title="Atividade coletiva">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="id"
                    @click="printFicha()"
                    color="info"
                >
                    Imprimir ficha
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    @redirect="redirect"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import Form from '@/components/atencao-basica/atividade-coletiva/Form'

// Vuex.
import { mapActions } from 'vuex';

// Mixins
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {
        this.setShowExitFormConfirmation()

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.atencaoBasica')
        }
    },
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
            'setLoading',
            'unsetLoading'
        ]),
        handleExit() {
            this.$router.push({ name: 'atencao-basica-atividade-coletiva' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        printFicha() {

            this.setLoading()

            this.repositories.impressao.fichaAtividadeColetiva(this.id)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        redirect(id) {

            this.unsetShowExitFormConfirmation()
            this.$router.push({ name: 'atencao-basica-atividade-coletiva-edit', params: { id: id } })
        },
    },
    mixins: [repository, error, object, data],
    props: {
        id: { type: Number, default: null }
    }
}
</script>